<template>
    <div style="width:100%;height:100%;">
        <div class="prism-player" :id="playerId" style="width:100%;height:100%;"></div>
    </div>
</template>

<script>
export default {
    name: "VideoPlayer",
    props: {
        source: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            // 播放器实例
            player: null,
            // 唯一 ID，避免多实例冲突
            playerId: 'vp_' + Math.random().toString(36).substr(2, 9),
            //没有进度条
            sowingSkinLayout: [
                {
                    name: "bigPlayButton",
                    align: "blabs",
                    x: 30,
                    y: 80,
                },
                {
                    name: "H5Loading",
                    align: "cc",
                },
                {
                    name: "errorDisplay",
                    align: "tlabs",
                    x: 0,
                    y: 0,
                },
                {
                    name: "infoDisplay",
                },
                {
                    name: "tooltip",
                    align: "blabs",
                    x: 0,
                    y: 56,
                },
                {
                    name: "thumbnail",
                },
                {
                    name: "controlBar",
                    align: "blabs",
                    x: 0,
                    y: 0,
                    children: [
                        {
                            name: "playButton",
                            align: "tl",
                            x: 15,
                            y: 12,
                        },
                        {
                            name: "timeDisplay",
                            align: "tl",
                            x: 10,
                            y: 7,
                        },
                        {
                            name: "fullScreenButton",
                            align: "tr",
                            x: 10,
                            y: 12,
                        },
                        {
                            name: "volume",
                            align: "tr",
                            x: 5,
                            y: 10,
                        },
                    ],
                },
            ],
            //有进度条
            noSowingskinLayout: [
                {
                    name: "bigPlayButton",
                    align: "blabs",
                    x: 30,
                    y: 80,
                },
                {
                    name: "H5Loading",
                    align: "cc",
                },
                {
                    name: "errorDisplay",
                    align: "tlabs",
                    x: 0,
                    y: 0,
                },
                {
                    name: "infoDisplay",
                },
                {
                    name: "tooltip",
                    align: "blabs",
                    x: 0,
                    y: 56,
                },
                {
                    name: "thumbnail",
                },
                {
                    name: "controlBar",
                    align: "blabs",
                    x: 0,
                    y: 0,
                    children: [
                        {
                            name: "progress",
                            align: "blabs",
                            x: 0,
                            y: 44,
                        },
                        {
                            name: "playButton",
                            align: "tl",
                            x: 15,
                            y: 12,
                        },
                        {
                            name: "timeDisplay",
                            align: "tl",
                            x: 10,
                            y: 7,
                        },
                        {
                            name: "fullScreenButton",
                            align: "tr",
                            x: 10,
                            y: 12,
                        },
                        {
                            name: "volume",
                            align: "tr",
                            x: 5,
                            y: 10,
                        },
                    ],
                },
            ],
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.inIt(this.source);
        });
    },
    methods: {
        //初始化控件
        inIt(sourceKey) {
            if (this.player !== null) {
                this.player.dispose();
            }
            this.player = new Aliplayer(
                {
                    id: this.playerId,
                    autoplay: false,
                    showBarTime: 3000000,
                    skinLayout: this.noSowingskinLayout,
                    useH5Prism: true,
                    source: sourceKey,
                },
                (player) => {
                    // 暂停事件
                    player.on("pause", () => {
                        this.$emit('paused', this);
                    });

                    // 开始播放事件
                    player.on("play", () => {
                        this.$emit('playing', this);
                    });

                    // 结束播放事件
                    player.on("ended", () => {
                        this.$emit('ended', this);
                        // let flagIsFullScreen =
                        //     this.player.fullscreenService.getIsFullScreen();
                        // if (flagIsFullScreen) {
                        //     this.player.fullscreenService.cancelFullScreen();
                        // }
                    });
                }
            );
        },

        playing() {
            this.player.playing();
        },

        //播放完毕
        ended() {
            this.player.ended();
        },

        //暂停事件
        pause() {
            this.player.pause();
        },

        //播放事件
        play() {
            this.player.play();
        },

    },

};
</script>

<style>
.prism-player {
    background-color: #fafbfc !important;
}

.prism-player .prism-cover {
    background-size: contain !important;
}

.prism-player .prism-liveshift-progress .prism-progress-played, .prism-player .prism-progress .prism-progress-played {
    background-color: #2563eb !important;
}
</style>
